import React from "react";
import PasswordInput from "../../../shared/components/imput/PasswordInput";
import { TriangleAlert } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function LoginForm({ formData, handleChange, handleSubmit, isLoading ,error,shake}) {
  const {changePassMethod} = useAuth();
  return (
    <>
      <div className="logo-wrapper-login">
        <div className="logo-container">
          <img
            src="/img/base_logo.png"
            alt="Tu Farmacia en el Bolsillo"
            className="app-logo"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        </div>

        <div className="logo-fallback" style={{ display: "none" }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z" />
            <path d="M12 8v8M8 12h8" strokeLinecap="round" />
          </svg>
        </div>
      </div>

      <div className="brand-header">
        <h1>Tu <span className="highlight">Farmacia</span></h1>
        <h1>en el <span className="highlight">Bolsillo</span></h1>
      </div>

      {/* Mensaje de error */}
      {error && (
        <div className="error-message">
          <TriangleAlert size={26} />
          {error}
        </div>
      )}

      <form 
        className={`login-form ${shake ? 'shake-animation' : ''}`} 
        onSubmit={handleSubmit}
      >
        <div className="input-field">
          <label htmlFor="identifier">Usuario</label>
          <input
            id="identifier"
            type="text"
            name="identifier"
            value={formData.identifier}
            onChange={handleChange}
            placeholder="Ingresa tu usuario"
            autoComplete="identifier"
          />
        </div>

        <div className="input-field">
          <PasswordInput formData={formData} handleChange={handleChange} tittle="Contraseña"/>
        </div>

        <button
          type="submit"
          className={`submit-btn ${isLoading ? "loading" : ""}`}
          disabled={isLoading || !formData.identifier || !formData.password}
        >
          {isLoading ? <span className="loader" /> : "Iniciar Sesión"}
        </button>
      </form>

      <div className="form-footer">
             <button 
                type="button"
                className="text-link"
                onClick={() => {
                    changePassMethod(true);
                }}
                style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontFamily: 'inherit',
                fontSize: 'inherit',
                padding: 0
                }}
             >
              ¿Olvidaste tu contraseña?
            </button>
      </div>
    </>
  );
}
